import { render, staticRenderFns } from "./EkrmChannelCard.vue?vue&type=template&id=1d384b9a&scoped=true&"
import script from "./EkrmChannelCard.vue?vue&type=script&lang=js&"
export * from "./EkrmChannelCard.vue?vue&type=script&lang=js&"
import style0 from "./EkrmChannelCard.vue?vue&type=style&index=0&id=1d384b9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d384b9a",
  null
  
)

export default component.exports